import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, CheckCircle, ArrowLeft } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
export function VerifyEmailPage() {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  const [resent, setResent] = useState(false);
  const handleResend = () => {
    setResent(true);
    setTimeout(() => setResent(false), 4000);
  };
  return <div className="min-h-screen bg-aliceBlue flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-530">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center" data-id="element-531">
        <Link to="/" data-id="element-532">
          <img src="https://cdn.magicpatterns.com/uploads/u4AKTM42BTBGHrLv1PiYxT/Logo_3.png" alt="LawVo" className="h-10 object-contain mx-auto mb-8" data-id="element-533" />
        </Link>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-534">
        <div className="bg-white py-10 px-6 shadow-sm sm:rounded-xl sm:px-10 border border-borderColor text-center" data-id="element-535">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-aliceBlue mb-6" data-id="element-536">
            <Mail className="h-8 w-8 text-violetBlue" data-id="element-537" />
          </div>
          <h2 className="text-2xl font-bold text-primary mb-3" data-id="element-538">
            Check your email
          </h2>
          <p className="text-secondary mb-2" data-id="element-539">
            We've sent a verification link to
          </p>
          <p className="font-semibold text-primary mb-6" data-id="element-540">
            {user?.email || 'your email address'}
          </p>
          <p className="text-sm text-secondary mb-8" data-id="element-541">
            Click the link in the email to verify your account and continue
            setting up your Legal Health Check.
          </p>

          <div className="space-y-3" data-id="element-542">
            <button onClick={() => navigate('/onboarding/welcome')} className="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-lg shadow-sm text-sm font-semibold text-white bg-violetBlue hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violetBlue transition-opacity" data-id="element-543">
              I've Verified My Email
            </button>

            <button onClick={handleResend} disabled={resent} className="w-full flex justify-center items-center py-3 px-4 border border-borderColor rounded-lg text-sm font-semibold text-primary bg-white hover:bg-aliceBlue transition-colors disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-544">
              {resent ? <>
                  <CheckCircle className="w-4 h-4 mr-2 text-turquoise" data-id="element-545" />
                  Email sent
                </> : 'Resend Verification Email'}
            </button>
          </div>

          <div className="mt-6 pt-6 border-t border-borderColor" data-id="element-546">
            <p className="text-xs text-secondary mb-3" data-id="element-547">
              Didn't receive the email? Check your spam folder or try a
              different email address.
            </p>
            <Link to="/login" className="inline-flex items-center text-sm font-semibold text-secondary hover:text-primary transition-colors" data-id="element-548">
              <ArrowLeft className="w-4 h-4 mr-1" data-id="element-549" /> Back to log in
            </Link>
          </div>
        </div>
      </motion.div>
    </div>;
}